/**
 * Sentry Client-Side Initialization
 * This file is automatically loaded by Next.js on the client side.
 * It's a convention-based file - no explicit import is needed.
 * @see https://docs.sentry.io/platforms/javascript/guides/nextjs/manual-setup/
 */
;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.4";import * as Sentry from "@sentry/nextjs"

import {
  API_HOST,
  FEAT_SENTRY_ENABLED,
  FEAT_SENTRY_REPLAY_ENABLED,
  IS_PRODUCTION,
  IS_STAGING,
  SENTRY_DSN,
} from "./src/lib/config"
import { createBeforeSend, createTracesSampler } from "./src/lib/sentry-config"

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    ...(FEAT_SENTRY_REPLAY_ENABLED
      ? [
          Sentry.replayIntegration({
            // Admin panel intentionally captures all text for internal debugging.
            // This is acceptable for internal admin users with access to sensitive data.
            // Review this setting if admin access is expanded to external users.
            maskAllText: false,
            blockAllMedia: true,
            // API_HOST is the admin app's URL (e.g., admin.supliful.com).
            // This is correct because Sentry Replay captures requests as seen by the browser.
            // The browser requests /graphql and /trpc/admin on the admin domain,
            // which Next.js then rewrites server-side to the actual API (api.supliful.com).
            // Using ADMIN_API_URL would NOT work - the browser never sees that URL directly.
            networkDetailAllowUrls: [API_HOST].filter(Boolean),
          }),
        ]
      : []),
  ],
  enabled: IS_PRODUCTION || FEAT_SENTRY_ENABLED,
  environment: IS_PRODUCTION
    ? "production"
    : IS_STAGING
      ? "staging"
      : "development",
  release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampler: createTracesSampler({
    isProduction: IS_PRODUCTION,
    isClient: true,
  }),
  beforeSend: createBeforeSend(),
  // Reduced from 0.1 to 0.05 (10% → 5%) for general session coverage
  replaysSessionSampleRate: 0.05,
  // Reduced from 1.0 to 0.5 (100% → 50%) to stay within 500/month replay quota
  // Still prioritizes error sessions for high-value debugging data
  replaysOnErrorSampleRate: 0.5,
})
